angular.module('picmonic-common').factory('GroupBuyResource', [
  '$resource',
  function ($resource) {
    return $resource('/api/v3/group_buy/:slug/:resource', {
      slug: '@slug',
      resource: '@resource',
    });
  },
]);
